'use strict';

var chunk2TH372SW_js = require('../chunk-2TH372SW.js');
var chunkB3Z3PVEB_js = require('../chunk-B3Z3PVEB.js');
var chunk5WVHVQDL_js = require('../chunk-5WVHVQDL.js');
var chunkRP7HQ6KN_js = require('../chunk-RP7HQ6KN.js');
require('../chunk-3CUP7X6U.js');
var chunkHUKGHOBJ_js = require('../chunk-HUKGHOBJ.js');
require('../chunk-S7FZ7BAB.js');
require('../chunk-M632V57T.js');
var o = require('react');
var d = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var o__default = /*#__PURE__*/_interopDefault(o);
var d__default = /*#__PURE__*/_interopDefault(d);

var te=d__default.default.div`
  display: flex;
  flex-direction: column;
  gap: ${({$gap:e})=>e};
  width: 100%;
  min-width: 100%;
`,ne=d__default.default.div`
  height: ${({$height:e})=>e};
  border-radius: ${({$conrnerRadius:e})=>e};
  background-color: ${({$backgroundColor:e})=>e};
  border: 1.5px solid;
  display: flex;
  gap: ${({$gap:e})=>e};
  overflow: hidden;
  padding: ${({$padding:e})=>e};
  align-items: center;
  justify-content: space-between;
  min-width: 100%;

  ${({$isActive:e,$isError:t,$errorBorderColor:u,$activeBorderColor:h,$borderColor:s,$disabled:a,$disabledBorderColor:f,$isVerified:n,$verifiedBorderColor:p})=>a?`
        border-color: ${f};
      `:e?`
        border-color: ${h};
      `:t?`
        border-color: ${u};
      `:n?`
        border-color: ${p};
    `:`
      border-color: ${s};
    `}
`,le=d__default.default.label`
  font-size: ${({$fontSize:e})=>e};
  line-height: ${({$lineHeight:e})=>e};
  color: ${({$color:e})=>e};
  font-weight: ${({$fontWeight:e})=>e};
`,O=d__default.default.div`
  display: flex;
  align-items: center;
  gap: 4px;

  & p{
    font-size: ${({$fontSize:e})=>e};
    line-height: ${({$lineHeight:e})=>e};
    color: ${({$color:e})=>e};
    margin-block: 0;
  }
`,ie=d__default.default.input`
  outline: none;
  border: none;

  height: 100%;
  width: 100%;
  flex: 1;
  font-size: ${({$fontSize:e})=>e};
  line-height: ${({$lineHeight:e})=>e};
  color: ${({$color:e})=>e};
  background-color: transparent;
  text-transform: ${({$transformValue:e})=>e};
  transition: transform 0.2s;

  &::placeholder {
    color: ${({$placeholderColor:e})=>e};
  }

  &:focus,
  &:active {
    outline: none;
    border: none;
  }

  &:disabled {
    color: ${({$disabledColor:e})=>e};
  }
`,de=d__default.default.span`
  display: flex;
  width: fit-content;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: ${({$fontSize:e})=>e};
  line-height: ${({$lineHeight:e})=>e};
  color: ${({$color:e})=>e};
  font-weight: ${({$fontWeight:e})=>e};
  padding-right: 8px;
  ${({$borderColor:e,$borderd:t})=>{if(t)return `
        border-right: 1px solid ${e};
      `}}
`,ue=({type:e="text",onChange:t,value:u,validator:h=()=>!0,label:s="Label",name:a,hint:f,customErrorMessage:n="",allowClear:p=!0,onClear:I=()=>{},placeholder:V="",required:j=!1,prefix:H,isPrefixBorder:A=!1,onFocus:c,onBlur:$,onClick:v,disabled:g=!1,onCopy:q,onCut:D,onPaste:G,suffix:x,isError:b=!1,isVerified:J=!1,maxLength:K=255,transformValue:N="",theme:P="default"})=>{let{tokens:l}=chunkHUKGHOBJ_js.b(),{variants:Q}=chunk2TH372SW_js.a(l),r=Q[P],[y,R]=o.useState(b),[m,z]=o.useState(!1),[U,S]=o.useState(n),E=o.useRef(null),X=g?l.background_fill_default_fill_disabled:P==="orbit"?"inherit":l.background_fill_default_fill_primary;o.useEffect(()=>{R(b);},[b]),o.useEffect(()=>{n&&S(n);},[n]);let Y=i=>{h(i.target.value)?S(""):S(n||"Please enter valid value"),t&&(t==null||t(i));},Z=()=>{g||typeof I=="function"&&I();},ee=chunkB3Z3PVEB_js.a(i=>{$&&($==null||$(i)),z(!1);},300),re=i=>{var L;if(typeof v!="function")z(!0);else {(L=E.current)==null||L.blur();return}c&&(c==null||c(i));};return o__default.default.createElement(te,{$gap:r.gap,onClick:v},s&&o__default.default.createElement(le,{htmlFor:a,$color:r.labelColor,$fontSize:r.fontSize,$lineHeight:r.lineHeight,$fontWeight:r.labelFontWeight},s,j&&o__default.default.createElement("span",{style:{color:r.errorColor}},"*")),o__default.default.createElement(ne,{$isActive:m,$isError:!!y,$isVerified:J,$activeBorderColor:r.activeBorderColor,$borderColor:r.borderColor,$conrnerRadius:r.cornerRadiusTokens,$errorBorderColor:r.errorBorderColor,$gap:r.gap,$height:l.size_44,$padding:`${l.spacing_10} ${l.spacing_12}`,$disabled:g,$disabledBorderColor:r.disabledBorderColor,$backgroundColor:X,$verifiedBorderColor:r.verifiedBorderColor},H&&o__default.default.createElement(de,{$fontSize:r.fontSize,$lineHeight:r.lineHeight,$borderd:A,$borderColor:r.prefixBorderColor,$color:r.prefixColor,$fontWeight:r.prefixFontWeight},H),o__default.default.createElement(ie,{type:chunk2TH372SW_js.c[e],value:u,onChange:Y,name:a,placeholder:V||chunk2TH372SW_js.b[e],onFocus:re,onBlur:ee,$color:r.color,$fontSize:r.fontSize,$lineHeight:r.lineHeight,$placeholderColor:r.placeholderColor,disabled:g,$disabledColor:r.disabledColor,onCopy:q,onPaste:G,onCut:D,ref:E,maxLength:K,$transformValue:N}),p&&m&&o__default.default.createElement(chunk5WVHVQDL_js.a,{fill:r.iconColor,onClick:Z}),(!m||!p)&&o__default.default.isValidElement(x)&&x),f&&!y&&o__default.default.createElement(O,{$color:r.placeholderColor,$fontSize:r.errorFontSize,$lineHeight:r.errorLineHeight},f),y&&o__default.default.createElement(O,{$color:r.errorColor,$fontSize:r.errorFontSize,$lineHeight:r.errorLineHeight},o__default.default.createElement(chunkRP7HQ6KN_js.a,{size:r.errorIconSize,fill:r.errorColor}),o__default.default.createElement("p",null,U)))};

exports.InputForm = ue;
